import { isEmpty, split } from 'ramda';
import validateEmail from './validateEmail';

/**
 *
 * @param {Object} values
 * @param {Object} schema
 */
const validateV2 = (values, schema) => {
  let errors = {};
  const keys = Object.keys(values);

  // TODO
  // do your logic
  keys.forEach((key, index) => {
    try {
      if (
        schema?.[key]?.type === 'email' ||
        schema?.[key]?.type?.includes('email')
      ) {
        if (schema[key].required && isEmpty(values[key])) {
          errors[key] = `This field is required`;
        }
        if (!isEmpty(values[key]) && !validateEmail(values[key])) {
          errors[key] = 'Invalid email';
        }
      }
      if (
        schema?.[key]?.type === 'string' ||
        schema?.[key]?.type?.includes('string')
      ) {
        if (schema[key].required && isEmpty(values[key])) {
          errors[key] = `This field is required`;
        }
      }
      if (
        schema?.[key]?.type === 'number' ||
        schema?.[key]?.type?.includes('number')
      ) {
        if (schema[key].required && isEmpty(values[key])) {
          errors[key] = `This field is required`;
        }
        if (isNaN(values[key])) {
          errors[key] = `This field must be a number`;
        }
      }
      if (Array.isArray(values[key])) {
        if (schema[key]?.required && values[key].length === 0) {
          errors[key] = `This field is required`;
        }
      }

      if (
        schema?.[key]?.type === 'file' ||
        schema?.[key]?.type?.includes('file')
      ) {
        /**
         * @type File
         */
        const files = values[key];

        const allowedTypes = schema?.[key]?.allowedTypes;
        const maxSize = schema?.[key]?.file_size?.max_value;
        const allowedSize = Number(maxSize) * 1000 * 1000;

        if (schema[key]?.required && isEmpty(values[key])) {
          errors[key] = `This field is required`;
        }

        if (!isEmpty(files)) {
          if (!Array.isArray(files)) {
            files = [files];
          }

          files.forEach((file) => {
            const fileNameArr = split('.', file.name);
            const fileExt = fileNameArr[fileNameArr.length - 1];

            if (allowedTypes) {
              if (!allowedTypes.includes(fileExt)) {
                errors[key] = `Invalid type. Allowed type: (${allowedTypes}) `;
              }
            }

            if (allowedSize) {
              if (file.size > allowedSize) {
                errors[key] = `File too large. Max size: (${allowedSize}kb) `;
              }
            }
          });
        }
      }
      if (values[key]?.fields) {
        const newValues = values[key]?.fields;
        const newSchema = schema?.[key]?.fields;

        if (!isEmpty(validateV2(newValues, newSchema))) {
          errors[values[key].type] = validateV2(newValues, newSchema);
        }
      }
    } catch (error) {
      console.log(error);
    }
  });
  return errors;
};

export default validateV2;
